<mat-dialog-content class="mat-typography">
  <img [src]="previewCapture()" style="width: 100%" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="true" (click)="delete()">
    <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-document-scan.preview-dialog.button.delete"></sc-dictionary-label>
  </button>
  <button mat-stroked-button [mat-dialog-close]="true" (click)="close()" cdkFocusInitial>
    <sc-dictionary-label dictionaryKey="shared.action.close"></sc-dictionary-label>
  </button>
</mat-dialog-actions>
